// extracted by mini-css-extract-plugin
module.exports = {"comp":"Animation1_comp__lqB1S","title":"Animation1_title__r8MEq"};